import React from "react";
import { ListingAppointedAgent } from "../../../../domain/codecs/Listing";
import { TListingDataFormIO } from "../../../../domain/codecs/formIO/ListingDataFormIO";
import { TListingFull1Editable } from "../../../../domain/codecs/formEditable/ListingEditable";
import { CRMAutosaveIndicatorWrap } from "../CRM/CRMAutosaveIndicatorWrap/CRMAutosaveIndicatorWrap";
import { CRMCodecEditForm } from "../CRMCodecEditForm/CRMCodecEditForm";
import { CRMParagraph } from "../Simple/CRMParagraph/CRMParagraph";
import { CRMSpacingColumn } from "../CRMSpacingColumn/CRMSpacingColumn";
import { CRMTitleSection } from "../CRMTitleSection/CRMTitleSection";
import { CRMTitleSubSection } from "../CRMTitleSubSection/CRMTitleSubSection";

type TProps = {
    listingPageData: TListingDataFormIO;
    onChange: (form: TListingFull1Editable) => void;
};

export const CRMListingAppointedAgentForm = (props: TProps): JSX.Element => {
    const { form, read_only } = props.listingPageData.output;

    return (
        <CRMAutosaveIndicatorWrap status={form.status}>
            <CRMSpacingColumn spacing="large">
                <CRMTitleSection>Appointed agent</CRMTitleSection>
                <CRMParagraph>
                    Enter the agent details and signed agreement date before changing the marketing route to appointed agent.
                </CRMParagraph>
                <CRMParagraph>
                    This records the appointment only. Continue to handle viewing, offer and buyer checks through the current process until the appointed-agent workflow is released.
                </CRMParagraph>
                {form.status === "validationError" &&
                    <CRMParagraph>Complete the required appointment details, then save the marketing route.</CRMParagraph>
                }
                <CRMCodecEditForm
                    codec={ListingAppointedAgent}
                    model={form.edited}
                    validationErrors={form.validationErrors}
                    onChange={(edited) => props.onChange({
                        ...form,
                        edited: { ...form.edited, ...edited },
                    })}
                />
                {read_only.appointed_agent_history.length > 0 && <>
                    <CRMTitleSubSection>Appointment history</CRMTitleSubSection>
                    {read_only.appointed_agent_history.map((appointment) =>
                        <CRMParagraph key={appointment.id}>
                            {appointment.agent_name} — {appointment.started_at.slice(0, 10)} to {appointment.ended_at?.slice(0, 10) ?? "current"}
                            {appointment.agreement_reference ? ` (${appointment.agreement_reference})` : ""}
                        </CRMParagraph>
                    )}
                </>}
            </CRMSpacingColumn>
        </CRMAutosaveIndicatorWrap>
    );
};
